export default "__VITE_ASSET__DcxP$Ua___"